import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { ICommAutoCertificateofInsurance } from "./commAutoCertificateofInsurance.types";


export const fetchCommAutoCertificateOfInsuranceList = createAsyncThunk<
  {
    data: ICommAutoCertificateofInsurance[];
    totalRecords: number;
  },
  {
    customerPolicyId: number;
    type: string;
    pageNumber: number;
    rowPerPage: number;
    status?: string;
  }
>(
  "commAutoCertificateOfInsurance/fetchCommAutoCertificateOfInsuranceList",
  async (
    { customerPolicyId, type, pageNumber, rowPerPage, status },
    { rejectWithValue },
  ) => {
    try {
      let url = `/policy/get-policy-commercial-and-automobile-all-policy-forms?customer_policy_id=${customerPolicyId}&policy_form_type=${type}&pageNo=${pageNumber}&itemPerPage=${rowPerPage}`;

      if (status && status !== "-1") {
        url += `&status=${status}`;
      }
      const res = await api.get(url);
      const data: ICommAutoCertificateofInsurance[] = res.data.data;
      const totalRecords = res.data.totalRecords;

      return {
        data: data || [],
        totalRecords: totalRecords || 0,
      };
    } catch (err: any) {
      return rejectWithValue(err);
    }
  },
);
